module.exports = __webpack_public_path__ + "img/news4.168d18d7.svg";